import React from "react";
export default function ExcerciseComponent() {
  return <h4>Hướng dẫn làm bài tập tương tác</h4>;
}
